import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export type BarcodeProps = {
  width?: number
  height?: number
}

export const Barcode: FC<SvgIconProps> = ({ width, height, ...props }: BarcodeProps) => (
  <SvgIcon sx={{ width: width ?? 24, height: height ?? 24 }} {...props}>
    <path d="M5 9v6h3V9H5zM14 15V9h3v6h-3zM11 9v6h2V9h-2zM9 15V9h1v6H9zM18 9v6h1V9h-1z" />
    <path
      fillRule="evenodd"
      d="M2 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2zm1 12V7h18v10H3z"
      clipRule="evenodd"
    />
  </SvgIcon>
)
